/* Sham PDP add-to-cart. The rules below are pure and unit tested; the element
   in the second half of this file holds no plan state - bundleStorage is the
   source of truth and it is re-read on every add. */

(function (global) {
  'use strict';

  // Selling plan group 78023622960 "Subscribe and Save". Duplicated from
  // assets/sham-plan-selector.js on purpose - loading the cart selector on the
  // PDP for a 4-entry map would be worse. test_sham_pdp_atc.mjs fails if the
  // two maps diverge.
  var PLAN_IDS = {
    '1': '690388500784',
    '2': '690388468016',
    '3': '690388435248',
    '4': '690388402480',
  };

  function resolvePlanId(plan, subscribable) {
    if (!subscribable) return null;
    if (plan === null || plan === undefined) return null;
    var n = typeof plan === 'number' ? plan : parseInt(plan, 10);
    if (isNaN(n) || String(n) !== String(plan).trim()) return null;
    if (n === 0) return null;
    return PLAN_IDS[String(n)] || null;
  }

  function normaliseQuantity(raw, rule) {
    var min = rule && rule.min > 0 ? rule.min : 1;
    var step = rule && rule.step > 0 ? rule.step : 1;
    var n = parseInt(raw, 10);
    if (isNaN(n) || n < min) return min;
    if (step > 1) n = min + Math.floor((n - min) / step) * step;
    if (rule && rule.max && n > rule.max) {
      n = rule.max;
      if (step > 1) n = min + Math.floor((n - min) / step) * step;
    }
    return n;
  }

  // delta of 0 re-normalises in place, which is what a variant change needs:
  // the new variant's rule can strand the current value off-step.
  function stepStepper(current, delta, rule) {
    var min = rule && rule.min > 0 ? rule.min : 1;
    var step = rule && rule.step > 0 ? rule.step : 1;
    var raw = normaliseQuantity(current, rule) + delta * step;
    if (raw < min) return min;
    return normaliseQuantity(raw, rule);
  }

  function registryEntry(o) {
    var plans = { '0': { id: null, price: o.price } };
    if (o.subscribable) {
      Object.keys(PLAN_IDS).forEach(function (k) {
        plans[k] = { id: PLAN_IDS[k], price: o.price };
      });
    }
    return {
      quantity: o.quantity,
      max_quantity: o.maxQuantity,
      tags: o.tags,
      original_price: o.price,
      selling_plans: plans,
    };
  }

  var api = {
    PLAN_IDS: PLAN_IDS,
    resolvePlanId: resolvePlanId,
    normaliseQuantity: normaliseQuantity,
    stepStepper: stepStepper,
    registryEntry: registryEntry,
  };

  if (typeof customElements !== 'undefined' && typeof HTMLElement !== 'undefined') {

    function cartDrawer() {
      return document.querySelector('cart-drawer[data-cart-drawer]');
    }

    // Mirrors bundle-page.js's money() - same fallback for the rare case
    // Shopify.formatMoney has not loaded yet.
    function formatMoney(cents) {
      return window.Shopify && window.Shopify.formatMoney
        ? window.Shopify.formatMoney(cents, window.Shopify.money_format)
        : '$' + (cents / 100).toFixed(2);
    }

    // `updateCartDisplay` (g-cart.js:520) skips the `cart-items` key when swapping
    // containers and only uses it to drive the progress bar; the line items come
    // from whichever requested section contains `[data-cart-container]`, which is
    // the drawer's OWN section (g-cart-v2.liquid:104). g-cart.js:756 requests
    // `[this.parentSectionId, "cart-items"]` for exactly this reason, so the
    // drawer's `data-section-id` must be read at runtime rather than hardcoded.
    function cartSections() {
      var ids = ['cart-items'];
      var drawer = cartDrawer();
      if (drawer && drawer.dataset.sectionId) ids.push(drawer.dataset.sectionId);
      return ids.join(',');
    }

    // `cart-items` is nothing but `<script id="cart-json">{{ cart | json }}</script>`
    // (sections/cart-items.liquid) and g-cart.js:507-514 only truthiness-checks it,
    // so window.cart otherwise keeps its pre-add value while the fresh JSON is
    // fetched and thrown away. getCartTotal() reads window.cart and drives
    // addAndDeleteGift plus the free-gift and free-delivery thresholds; it is inert
    // on the PDP today only because there is no <progress-bar> here to reach it.
    function syncWindowCart(data) {
      var markup = data.sections && data.sections['cart-items'];
      if (!markup) return null;
      var doc = new DOMParser().parseFromString(markup, 'text/html');
      var script = doc.querySelector('#cart-json');
      if (!script) return null;
      window.cart = JSON.parse(script.textContent);
      return window.cart;
    }

    // The label counts `cart | item_count_for_variant`, which sums every line
    // holding the variant - and a variant occupies two lines when the cart holds
    // it both one-time and on a plan. The `cart-items` section already requested
    // above carries the whole post-add cart, so prefer it; cart/add.js's own
    // `items` entries cover only the lines this request touched and would
    // under-report in that case.
    function variantQuantityInCart(cart, data, variantId) {
      var lines = (cart && cart.items) || data.items || [];
      var total = 0;
      lines.forEach(function (line) {
        if (String(line.variant_id) === String(variantId)) total += line.quantity;
      });
      return total;
    }

    // initial-storage.liquid writes window.bundleStorage from a type="module"
    // script. Both it and this file sit in the same deferred queue, so document
    // order decides, and it wins today (theme.liquid:387 against a section
    // script inside content_for_layout). global.js:1278 dereferences it unguarded
    // from theme.liquid:49 and throws for exactly that reason - the throw is
    // allowlisted in console-baseline.json. Do not repeat it here:
    // settings.default_selling_plan is "0", so 0 is the right answer for a
    // session that has no stored plan.
    function currentPlan() {
      return window.bundleStorage && window.bundleStorage.delivery_plan != null
        ? window.bundleStorage.delivery_plan
        : 0;
    }

    // The line Shopify will merge this add into is the one matching both
    // variant AND selling plan - not bundleStorage.products[variantId], whose
    // registryEntry() quantity is a call-count total across every plan and so
    // cannot tell two lines on the same variant apart. window.cart is seeded
    // by initial-storage.liquid ({{ cart | json }}) and refreshed by
    // syncWindowCart() after every add, so it already reflects merges.
    function cartLineQuantity(variantId, sellingPlanId) {
      var items = (window.cart && window.cart.items) || [];
      var targetPlanId = sellingPlanId ? String(sellingPlanId) : null;
      var total = 0;
      items.forEach(function (item) {
        if (String(item.variant_id) !== String(variantId)) return;
        var itemPlanId = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
          ? String(item.selling_plan_allocation.selling_plan.id)
          : null;
        if (itemPlanId === targetPlanId) total += item.quantity;
      });
      return total;
    }

    class ShamPdpAtc extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-atc-button]');
        this.label = this.querySelector('[data-atc-label]');
        // Without both there is nothing to drive, and dereferencing them would
        // throw out of the upgrade and leave a permanently dead button.
        if (!this.button || !this.label) return;
        this.spinner = this.querySelector('[data-atc-spinner]');
        this.errorSlot = this.querySelector('[data-atc-error]');
        // The label is the localised `products.product.add_to_cart` string
        // ("Add to Cart" in en.default, translated across 32 locale files), so
        // markAdded() must restore what was rendered, never an English literal.
        this.defaultLabel = this.label.textContent.trim();
        this.soldOut = this.button.disabled;
        this.busy = false;
        // product-form.js:14, on the same condition. The drawer this opens is the
        // dialog the attribute promises.
        if (cartDrawer()) this.button.setAttribute('aria-haspopup', 'dialog');
        this.onClickBound = this.onClick.bind(this);
        this.button.addEventListener('click', this.onClickBound);

        this.clearError = this.showError.bind(this, '');
        this.volumeSlot = this.querySelector('[data-volume-slot]');
        this.priceRow = this.querySelector('[data-volume-price-row]');
        this.priceEl = this.querySelector('[data-pdp-variant-price]');
        this.compareEl = this.querySelector('[data-pdp-variant-compare]');
        this.pillEl = this.querySelector('[data-volume-pill]');
        this.updateVolumeSlotBound = this.updateVolumeSlot.bind(this);
        this.updateVolumeSlotBound();
        this.qtyMinus = this.querySelector('[data-atc-qty-minus]');
        this.qtyPlus = this.querySelector('[data-atc-qty-plus]');
        this.qtyAnnounce = this.querySelector('[data-atc-qty-announce]');
        this.onStepBound = this.onStep.bind(this);
        if (this.qtyMinus) this.qtyMinus.addEventListener('click', this.onStepBound);
        if (this.qtyPlus) this.qtyPlus.addEventListener('click', this.onStepBound);
        this.syncStepperBounds();

        // origin/live disables the button synchronously at the top of every variant
        // change - toggleAddButton(true, '', false), global.js:1049 - and re-enables
        // it only once the section render resolves. That call early-returns here
        // because it looks up the removed `#product-form-<section>`, leaving the
        // button live for the whole render (200-600ms, worse on mobile) while the
        // dataset still holds the previous variant and updateURL has already moved
        // `?variant=`. renderProductInfo has no .catch either, so an aborted or
        // failed fetch never publishes and would strand a stale dataset behind an
        // enabled button indefinitely. Disabling here restores live's fail-closed
        // behaviour; onVariantChange is the only thing that re-enables.
        this.disableForRender = function () {
          this.button.disabled = true;
        }.bind(this);
        var picker = document.querySelector(
          'variant-radios[data-section="' + this.dataset.sectionId + '"], ' +
            'variant-selects[data-section="' + this.dataset.sectionId + '"]'
        );
        if (picker) {
          this.listenedPicker = picker;
          picker.addEventListener('change', this.disableForRender);
        }

        // global.js:1105-1113 kept the removed `input[name="id"]` in sync on every
        // variant change; renderProductInfo (global.js:1162-1235) swaps only the
        // `price-`/`Sku-`/`Inventory-`/`Volume-`/`Price-Per-Item-` ids and never
        // touches this block, so this subscription is the only thing keeping the
        // dataset on the selected variant. Guarded because constants.js/pubsub.js
        // are separate deferred scripts, not a hard dependency of this file.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.variantChange,
            this.onVariantChange.bind(this)
          );
        }

        // The drawer is the only other surface that mutates this variant's cart
        // line while the PDP stays mounted, and it publishes nothing through
        // pubsub: g-cart.js writes window.cart directly (:727) and flips its own
        // aria-expanded (:433), so that attribute is the entire signal.
        var drawer = cartDrawer();
        if (drawer) {
          this.drawerObserver = new MutationObserver(
            function () {
              if (drawer.getAttribute('aria-expanded') === 'false') this.refreshFromCart();
            }.bind(this)
          );
          this.drawerObserver.observe(drawer, {
            attributes: true,
            attributeFilter: ['aria-expanded'],
          });
        }
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
        if (this.button && this.onClickBound) {
          this.button.removeEventListener('click', this.onClickBound);
        }
        if (this.listenedPicker) {
          this.listenedPicker.removeEventListener('change', this.disableForRender);
        }
        if (this.qtyMinus) this.qtyMinus.removeEventListener('click', this.onStepBound);
        if (this.qtyPlus) this.qtyPlus.removeEventListener('click', this.onStepBound);
        if (this.drawerObserver) this.drawerObserver.disconnect();
      }

      onVariantChange(event) {
        var payload = event && event.data;
        if (!payload || !payload.html) return;
        if (payload.sectionId !== this.dataset.sectionId) return;
        // The `<a>` branch of the snippet renders instead of this element only
        // when `product.available` is false, which is product-scoped and so cannot
        // flip on a variant switch. Nothing to copy means nothing to guess.
        var incoming = payload.html.querySelector('sham-pdp-atc');
        if (!incoming) return;

        this.syncDataset(incoming);
        this.syncStepperBounds();
        this.updateVolumeSlot();
        if (window.cart) {
          this.updateCartQuantityLabel(
            variantQuantityInCart(window.cart, {}, this.dataset.variantId)
          );
        }

        var incomingButton = incoming.querySelector('[data-atc-button]');
        if (incomingButton) this.soldOut = incomingButton.hasAttribute('disabled');
        // Outside the branch above: this is the only path that lifts the
        // disableForRender hold, and it must restore this.soldOut rather than
        // simply enabling, or a sold-out variant would come back clickable.
        if (!this.busy) this.button.disabled = this.soldOut;
        var incomingLabel = incoming.querySelector('[data-atc-label]');
        if (incomingLabel) {
          this.defaultLabel = incomingLabel.textContent.trim();
          this.label.textContent = this.defaultLabel;
        }
        this.showError('');
      }

      syncDataset(incoming) {
        var self = this;
        // This addresses the host section, not the variant: renderProductInfo
        // fetches `dataset.originalSection || dataset.section`, so in a quick-add
        // context the incoming section id is the *original* section's, and copying
        // it across would break every later sectionId match.
        var hostScoped = { sectionId: true };
        Object.keys(this.dataset).forEach(function (key) {
          if (!hostScoped[key] && !(key in incoming.dataset)) delete self.dataset[key];
        });
        Object.keys(incoming.dataset).forEach(function (key) {
          if (!hostScoped[key]) self.dataset[key] = incoming.dataset[key];
        });
      }

      // Quantity here is the stepper value PLUS whatever already sits on the
      // line this add will merge into (cartLineQuantity) - the tier this
      // component must key off, since that merged quantity is what the
      // discount function evaluates. this.pillEl is resolved once in
      // connectedCallback and passed explicitly rather than left to
      // renderSlot's querySelector fallback - two Criticals on this branch
      // came from exactly that fallback binding the wrong node elsewhere.
      updateVolumeSlot() {
        if (!window.ShamVolumeTiers) {
          this.updatePriceRow(null, parseInt(this.dataset.price, 10) || 0, 0);
          return;
        }
        var ladder = window.ShamVolumeTiers.readLadder(document);
        var variantId = this.dataset.variantId;
        var baseCents = parseInt(this.dataset.price, 10) || 0;
        var sellingPlanId = resolvePlanId(currentPlan(), this.dataset.subscribable === 'true');
        var merged = cartLineQuantity(variantId, sellingPlanId) + this.readQuantity();
        // The PM wants the chip to always show the static ladder summary
        // (renderSlot's qty===0 "hint" state), while the pill and price keep
        // tracking merged quantity - so the one call splits in two, each
        // touching only its own target.
        window.ShamVolumeTiers.renderSlot(this, {
          ladder: ladder,
          quantity: 0,
          baseCents: baseCents,
          slotEl: this.volumeSlot,
          pillEl: null,
        });
        var line = window.ShamVolumeTiers.renderSlot(this, {
          ladder: ladder,
          quantity: merged,
          baseCents: baseCents,
          slotEl: null,
          pillEl: this.pillEl,
        });
        this.updatePriceRow(line, baseCents, merged);
      }

      refreshFromCart() {
        this.updateVolumeSlot();
        if (!window.cart) return;
        this.updateCartQuantityLabel(
          variantQuantityInCart(window.cart, {}, this.dataset.variantId)
        );
      }

      // main-product.liquid gates bundle-price's visible block off entirely
      // when the flag is on (it never reflected a volume tier anyway), so
      // this row is the sole price line across the whole quantity range -
      // always visible, plain base price below the first tier, discounted
      // with its earned strike once a tier applies. Compare-at is
      // merchandising and strikes independently of any tier; the volume
      // strike only takes over once it would show a smaller base price.
      updatePriceRow(line, baseCents, qty) {
        if (!this.priceRow || !this.priceEl) return;
        var hasTier = !!line && line.percentage > 0;
        var unitCents = hasTier && qty > 0 ? Math.round(line.netCents / qty) : baseCents;
        this.priceEl.textContent = formatMoney(unitCents);
        if (this.compareEl) {
          var compareAtCents = parseInt(this.dataset.compareAtPrice, 10) || 0;
          var struckCents = compareAtCents > baseCents ? compareAtCents : baseCents;
          if (struckCents > unitCents) {
            this.compareEl.textContent = formatMoney(struckCents);
            this.compareEl.style.display = '';
          } else {
            this.compareEl.style.display = 'none';
          }
        }
        this.priceRow.style.display = '';
      }

      // Only the number, inside the span the locale string owns: `in_cart_html`
      // is `<span class="quantity-cart">{{ quantity }}</span> in cart` across all
      // 33 locale files. product-form.js replaced the whole wrapper's innerHTML
      // with an English literal and destroyed that span with it.
      updateCartQuantityLabel(count) {
        var wrapper = this.querySelector('[data-atc-in-cart]');
        if (!wrapper) return;
        var value = wrapper.querySelector('.quantity-cart');
        if (!value) return;
        value.textContent = count;
        wrapper.hidden = count <= 0;
      }

      get quantityInput() {
        return this.querySelector('[data-atc-qty-input]');
      }

      // product-form.js:93 used to publish cartUpdate and product-info.js's
      // setQuantityBoundries() reset the input off that; this component does not
      // publish cartUpdate, so the reset happens directly instead.
      // normaliseQuantity(dataset.min, {min: dataset.min}) clamps its own raw
      // value up to itself, which is exactly the min with the same
      // absent-dataset fallback normaliseQuantity already gives readQuantity().
      resetQuantity() {
        var input = this.quantityInput;
        if (!input) return;
        input.value = normaliseQuantity(this.dataset.min, { min: parseInt(this.dataset.min, 10) });
        this.syncStepperBounds();
      }

      readQuantity() {
        var input = this.quantityInput;
        return normaliseQuantity(input ? input.value : this.dataset.min, this.quantityRule());
      }

      onStep(event) {
        var input = this.quantityInput;
        if (!input) return;
        var delta = event.currentTarget === this.qtyPlus ? 1 : -1;
        input.value = stepStepper(input.value, delta, this.quantityRule());
        this.showError('');
        this.updateVolumeSlot();
        this.syncStepperBounds();
      }

      quantityRule() {
        return {
          min: parseInt(this.dataset.min, 10),
          step: parseInt(this.dataset.step, 10),
          max: this.dataset.max ? parseInt(this.dataset.max, 10) : null,
        };
      }

      // The input's own min/max/step attributes are the variant's, and
      // syncDataset() replaces the dataset on every variant change without
      // touching them - so they are re-written here rather than trusted.
      syncStepperBounds() {
        var input = this.quantityInput;
        if (!input) return;
        var rule = this.quantityRule();
        input.min = rule.min;
        input.step = rule.step > 0 ? rule.step : 1;
        if (rule.max) input.max = rule.max;
        else input.removeAttribute('max');
        input.value = stepStepper(input.value, 0, rule);
        if (this.qtyMinus) {
          this.qtyMinus.setAttribute(
            'aria-disabled',
            String(parseInt(input.value, 10) <= rule.min)
          );
        }
        if (this.qtyPlus) {
          this.qtyPlus.setAttribute(
            'aria-disabled',
            String(!!rule.max && parseInt(input.value, 10) >= rule.max)
          );
        }
        if (this.qtyAnnounce) {
          this.qtyAnnounce.textContent = this.dataset.qtyLabel + ': ' + input.value;
        }
      }

      setBusy(busy) {
        this.busy = busy;
        this.button.disabled = busy || this.soldOut;
        if (this.spinner) this.spinner.hidden = !busy;
      }

      showError(message) {
        if (!this.errorSlot) return;
        // Unhiding before the text lands is the more reliable announcement order
        // for a role="alert" region.
        this.errorSlot.hidden = !message;
        this.errorSlot.textContent = message;
      }

      async onClick() {
        if (this.button.disabled) return;
        this.showError('');
        this.setBusy(true);

        var variantId = this.dataset.variantId;
        var quantity = this.readQuantity();
        var subscribable = this.dataset.subscribable === 'true';
        var plan = window.bundleStorage ? window.bundleStorage.delivery_plan : 0;
        var sellingPlanId = resolvePlanId(plan, subscribable);

        var line = { id: variantId, quantity: quantity };
        if (sellingPlanId) line.selling_plan = sellingPlanId;

        var data;
        try {
          var response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [line], sections: cartSections() }),
          });
          data = await response.json();

          if (!response.ok) {
            throw new Error(data.description || data.message || 'Could not add to cart');
          }
        } catch (error) {
          // Nothing navigates away any more, so this message is the only signal
          // the customer gets. product-form.js rendered it and then destroyed it
          // in the same tick with its unconditional redirect.
          this.showError(error.message);
          this.setBusy(false);
          return;
        }

        // The line is in the cart by this point. Anything that fails below is a
        // bug in our own post-add work, and reporting it as an add failure tells
        // the customer nothing happened when something did.
        try {
          this.resetQuantity();
          this.registerVariant(variantId, quantity);
          var cart = syncWindowCart(data);
          this.updateVolumeSlot();
          this.refreshAndOpenDrawer(data);
          this.markAdded();
          // Last: a throw in here must not cost the customer the drawer.
          this.updateCartQuantityLabel(variantQuantityInCart(cart, data, variantId));
        } catch (error) {
          console.error('sham-pdp-atc: added to cart, but the post-add work failed', error);
        }
        this.setBusy(false);
        this.dispatchEvent(new CustomEvent('sham:pdp-added', { bubbles: true, detail: { variantId: variantId, quantity: quantity, subscribable: subscribable, sellingPlanId: sellingPlanId, items: data.items } }));
      }

      registerVariant(variantId, quantity) {
        if (!window.bundleStorage) return;
        if (!window.bundleStorage.products) window.bundleStorage.products = {};
        var existing = window.bundleStorage.products[variantId];
        var total = (existing ? existing.quantity : 0) + quantity;
        window.bundleStorage.products[variantId] = registryEntry({
          variantId: variantId,
          quantity: total,
          maxQuantity: this.dataset.maxQuantity,
          tags: this.dataset.tags,
          price: parseInt(this.dataset.price, 10),
          subscribable: this.dataset.subscribable === 'true',
        });
        // setItem throws QuotaExceededError in Safari private browsing. The
        // in-memory registry is what changeCartDeliveryPlan reads, so failing to
        // persist must not stop the drawer from opening.
        try {
          window.sessionStorage.setItem('bundleStorage', JSON.stringify(window.bundleStorage));
        } catch (error) {
          console.warn('sham-pdp-atc: could not persist bundleStorage', error);
        }
      }

      refreshAndOpenDrawer(data) {
        var drawer = cartDrawer();
        if (!drawer) return;
        if (typeof drawer.updateCartDisplay === 'function') drawer.updateCartDisplay(data);
        if (typeof drawer.setExpanded === 'function') drawer.setExpanded(true);
      }

      markAdded() {
        this.classList.add('is-added');
        this.label.textContent = 'Added';
        setTimeout(() => {
          this.classList.remove('is-added');
          this.label.textContent = this.defaultLabel;
        }, 2000);
      }
    }

    customElements.define('sham-pdp-atc', ShamPdpAtc);
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else global.ShamPdpAtcRules = api;

})(typeof globalThis !== 'undefined' ? globalThis : this);
